import React, { useState, useEffect, useContext, useRef } from 'react'
import { AppContext } from '../../../App'
import Spinner from '../../../components.js/elements/Spinner'
// NAVIGATION
import { useNavigate } from 'react-router-dom'
// COMPONENTS
import IdentificationChat from '../../../components.js/users/chatUser/IdentificationChat' 
import useFirebase from '../../../firebase/useFirebase'
import useForm from '../../../hooks/useForm'
import HeaderReturn from './../../../components.js/serveur/siteWeb/HeaderReturn'
import imageButtonChat from './../../../images/buttonChat.png'
import ModalConnect from './../../../components.js/users/homeUsers/ModalConnect'
import useAuthFirebase from '../../../firebase/useAuthFirebase'
import ModalCreateAccount from '../../../components.js/users/homeUsers/ModalCreateAccount'


const INITIAL_STATE = {
    message:'',
    surname:'',
    name:'',
    email:'',
    password:'',
}

const ChatUsersPage = () => {
    const { user } = useContext(AppContext) 
    const [keyUid, setKeyUid] = useState(localStorage.getItem('keyUid'))
    const [tokenUser, setTokenUser] = useState(localStorage.getItem('tokenUser'))
    const { handleChange, values, refresh } = useForm(INITIAL_STATE)
    const { readDataClients, updateData, readDataMessagesChat, writeData, clients, messagesChat } = useFirebase()
    const { _signIn, _forgotPassword, _signUp } = useAuthFirebase()
    const [montage, setMontage] = useState(true)
    const [count, setCount] = useState(0)
    const messagesEndRef = useRef(null)
    let navigate = useNavigate() 

    useEffect(() => {
        scrollToBottom()
        readDataMessagesChat(keyUid) 
        readDataClients(keyUid)
        setMontage(false)
        console.log('ChatUserPage useEffect')
    },[user.uid])

    const scrollToBottom = () => {
        // const { current } = messagesEndRef
        // current?.scrollIntoView({ behavior: "smooth" })
        // console.log('ChatUserPage scrollToBottom')
    }

    useEffect(() => {
        scrollToBottom()
        console.log('ChatUserPage useEffect2')
    },[messagesChat, count])

    // METHOD GET HOURS
    const _getHours = (date) => {
        const jour = new Date(date).getDate()
        const mois = new Date(date).getMonth() +1
        const annee = new Date(date).getFullYear()
        const hours = new Date(date).getHours()
        const minutes = new Date(date).getMinutes()

        const jourCurrent = new Date(Date.now()).getDate()
        const moisCurrent = new Date(Date.now()).getMonth() +1
        const anneeCurrent = new Date(Date.now()).getFullYear()

        if (jour !== jourCurrent || mois !== moisCurrent || annee !== anneeCurrent) {
            return (jour < 10 ? '0'+jour : jour) +'/'+(mois < 10 ? '0'+mois : mois)+'/'+annee
        } else {
            return (hours < 10 ? '0'+hours : hours) + ':' + (minutes < 10 ? '0'+minutes : minutes)
        }
    }

    // GET NEW
    const _getNew = (id) => {
        // UPDATE IS NEW
        const data = {isNew:false}
        updateData('entreprises/'+keyUid+'/messagesChat/'+id,data)
    }

    if (montage === null) return <Spinner />

    // METHODE ENREGISTRER MESSAGE
    const _writeMessage = (uidClient,name,surname) => {
        // CREATION DATA
        const data = {
            date:Date.now(),
            receiver:'administrateur',
            uidClient:uidClient,
            isNew:true,
            name:name,
            surname:surname,
            message:values.message,
        }
        // ECRIRE DANS LA BASE DE DONNEE
        writeData('entreprises/'+keyUid+'/messagesChat',data)
        refresh()
        // setCount(count +1)
    }

    return (
        <div className='container-fluid'>

            {/* HEADER */}
            <div>
                <div style={{ top: "0px", position: "fixed", width: "100%" }}>
                    <div className='row pb-2 border-bottom bg-body' onClick={() => navigate( '/homeUser/'+keyUid+'/'+tokenUser )} style={{ height:'4rem' }}>
                        <div className='col-1 text-start align-self-center'>
                            <span>
                                <i className="bi bi-arrow-left" style={{ fontSize:'1.8rem' }}></i>
                            </span> 
                        </div>
                        <div className='col text-start align-self-center'>
                            <span className='h5 text-center text-secondary'>CHAT</span>
                        </div>
                    </div>
                </div>
                <div style={{ height:'4rem'}}/>
            </div>

            <div className='mt-3'/>

            {/* SI CONNECTE */}
            {user.uid ? 
                <>
                    {/* CLIENT */}
                    {clients.filter(client => client.uid === user.uid).map(client => (
                        <div>
                            {/* MESSAGE */}
                            <div className='row mt-2 border-bottom'>
                                <div className='col-10'>
                                    <div className="text-center mt-2">
                                        <textarea 
                                            // className="form-control border-0 rounded p-2" 
                                            onChange={handleChange}   
                                            name='message' 
                                            rows="2" 
                                            placeholder='Saisir votre message...'
                                            value={values.message}
                                            style={{ border:'none', backgroundColor:'transparent', resize:'none', outline:'none', width:'100%', paddingLeft:5}}
                                        ></textarea>
                                    </div>
                                </div>

                                {/* BOUTTON ENOYER */}
                                <div className='col-2 text-end' 
                                    // onClick={() => _writeMessage(client.uid, client.name, client.surname)}
                                    onClick={() => values.message.trim() ? _writeMessage(client.uid, client.name, client.surname) : null }
                                >
                                    <img src={imageButtonChat} className='img-fluid me-2 mt-2' alt='image du logo' style={{ height:40, width:40 }} />
                                </div>
                            </div>
                        

                            <div key={client.uid} style={{marginBottom:150}}>
                                <div className='mb-4' style={{ overflow: 'smooth'}}>
                                    {messagesChat.filter(chat => chat.uidClient === user.uid).reverse().map(chat => (
                                        <div key={chat.id} className='row'>
                                            {chat.isNew && chat.receiver === 'client' && _getNew(chat.id)}
                                            {chat.receiver === 'administrateur' && <div className='col-4'></div>}
                                            <div 
                                                className='col rounded m-1 pb-1'
                                                // style={{ backgroundColor: 'lightgrey' }}
                                                style={{ backgroundColor: chat.receiver === 'administrateur' ? 'lightgrey' : 'lightblue' }}
                                            >
                                                <div className='text-center' style={{ fontSize:12}}>{_getHours(chat.date)}</div>
                                                <div style={{whiteSpace:'pre-line'}}>{chat.message}</div>
                                            </div>
                                            {chat.receiver === 'client' && <div className='col-4'></div>}
                                        </div>
                                    ))}
                                </div>

                            </div>
                        </div>
                        
                    ))}
                </>
                
            : 
                <>
                    <div className='mt-3'>Vous devez être connecté pour accéder au chat</div>
                    <IdentificationChat />
                </>             
            }

            {/* MODAL CREATE ACCOUNT */}
            <ModalCreateAccount
                handleChange={handleChange}
                values={values}
                keyUid={keyUid}
                _signUp={_signUp}
                token={tokenUser}
            /> 

            {/* MODAL CONNECT */}
            <ModalConnect
                handleChange={handleChange}
                values={values}
                _signIn={_signIn}
                _forgotPassword={_forgotPassword}
            /> 
        </div>
    )
}

export default ChatUsersPage

